import { throttle } from 'lodash-es';

const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

export default () => ({
	open: false,
	desktop: false,

	init() {
		const collapseOn = this.$el.getAttribute('data-collapse-on') || false;
		const mediaQuery = window.matchMedia('(min-width: 767px)');

		// Initial state
		if (collapseOn === 'all') {
			this.open = false;
		} else {
			this.desktop = mediaQuery.matches;
			this.open = this.desktop;

			if (this.desktop) {
				this.$el.classList.add('fact-box--no-collapse-desktop');
			}
		}

		// Only react when breakpoint changes, not every mobile scroll resize
		const handleBreakpointChange = (e) => {
			if (collapseOn === 'all') return;

			const wasDesktop = this.desktop;
			this.desktop = e.matches;

			// Only reset open state when crossing breakpoint
			if (wasDesktop !== this.desktop) {
				this.open = this.desktop;
			}

			if (this.desktop) {
				this.$el.classList.add('fact-box--no-collapse-desktop');
			} else {
				this.$el.classList.remove('fact-box--no-collapse-desktop');
			}
		};

		if (mediaQuery.addEventListener) {
			mediaQuery.addEventListener('change', handleBreakpointChange);
		} else {
			mediaQuery.addListener(handleBreakpointChange);
		}

		// Keep collapsed content out of tab order when closed
		this.$watch('open', (isOpen) => {
			this._setContentFocusable(isOpen);

			// When opening, move focus to the top of the box so reading order starts there
			if (isOpen) {
				this.$nextTick(() => {
					const target = this.$el.querySelector('.fact-box__title') || this.$el;
					if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
					target.focus({ preventScroll: false });
				});
			}
		});
		this.$nextTick(() => this._setContentFocusable(this.open));
	},

	_setContentFocusable(isOpen) {
		const content = this.$el.querySelector('.js_fact-box');
		if (!content) return;
		content.querySelectorAll(FOCUSABLE).forEach((el) => {
			if (isOpen) {
				el.removeAttribute('tabindex');
			} else {
				el.setAttribute('tabindex', '-1');
			}
		});
	},
});
